import { render, staticRenderFns } from "./WheelOptionsCollapse.vue?vue&type=template&id=4e2747bc&"
import script from "./WheelOptionsCollapse.vue?vue&type=script&lang=ts&"
export * from "./WheelOptionsCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./WheelOptionsCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports